import { ref } from 'vue';

import { fetch_app_data } from '../_partials/_app.js';

const geo_origin = ref(null);

let promise = null;

export function use_geo_origin() {
	return geo_origin;
}

export function fetch_geo_origin(api_url) {
	if (geo_origin.value || promise) {
		return promise;
	}

	promise = fetch_app_data(api_url, `/api/listings/geo-origin`)
		.then((response) => {
			geo_origin.value = response.data;
		})
		.catch((error) => {
			// eslint-disable-next-line no-console
			console.error(error);
		});

	return promise;
}
